import { Lock } from '@phosphor-icons/react';
import { useAuthStore } from '@/features/auth/store';
import { useClerkWorkspaceStore, type PermissionCode } from '@/lib/clerkWorkspaceStore';

interface Props {
  permission: PermissionCode;
  children: React.ReactNode;
}

export function ClerkPermissionGuard({ permission, children }: Props) {
  const memberType = useAuthStore((s) => s.user?.memberType);
  const hasPermission = useClerkWorkspaceStore((s) => s.hasPermission(permission));
  const barristerName = useClerkWorkspaceStore((s) => {
    const ws = s.activeBarristerId
      ? s.workspaces.find((w) => w.barristerId === s.activeBarristerId)
      : s.workspaces[0];
    return ws?.barristerName;
  });

  const isClerk = memberType === 'senior_clerk' || memberType === 'junior_clerk';

  if (!isClerk || hasPermission) {
    return <>{children}</>;
  }

  return (
    <div className="flex h-full min-h-[400px] flex-col items-center justify-center gap-4 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-ink-800">
        <Lock className="h-5 w-5 text-ink-400" />
      </div>
      <div>
        <p className="text-sm font-medium text-white">Access not granted</p>
        <p className="mt-1 max-w-xs text-xs text-ink-400">
          {barristerName
            ? `${barristerName} has not granted access to this section.`
            : 'You do not have access to this section.'}
        </p>
      </div>
    </div>
  );
}
